'use client';
import type { RefObject } from 'react';
import { VisualContainer } from '@/components/Visualization/VisualContainer/index';
import type { ChartValues } from '@/types/chart';
import { TimeChart as Chart } from './TimeChart';

interface Props {
  data: ChartValues[][];
  isLoading?: boolean;
  isError?: boolean;
  onErrorHandler?: () => void;
  height?: number;
  ref?: RefObject<HTMLDivElement | null>;
  className?: string;
  showAnnotations?: boolean;
  unit?: string;
  noDataMessage?: string;
}

export const TimeChart = ({
  ref,
  data,
  isLoading = false,
  isError = false,
  onErrorHandler,
  height = 340,
  className,
  showAnnotations = false,
  unit = '',
  noDataMessage,
}: Props) => {
  return (
    <VisualContainer
      ref={ref}
      data={data}
      isError={isError}
      onErrorHandler={onErrorHandler}
      isLoading={isLoading}
      height={height}
      className={className}
      noDataMessage={noDataMessage}
    >
      {({ width }) => (
        <Chart
          key={JSON.stringify(data)}
          height={height}
          width={width}
          data={data}
          unit={unit}
          showAnnotations={showAnnotations}
        />
      )}
    </VisualContainer>
  );
};

TimeChart.displayName = 'TimeChart';
